// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Grid } from '@material-ui/core';

const FloatingControlsContainer = ({ children, classes, withMenu }) => {
  const rootClass = withMenu ? classes.withMenu : classes.actionBarContainer;
  return (
    <Container maxWidth="sm" classes={{ root: rootClass }}>
      <Grid container spacing={2}>
        {children}
      </Grid>
    </Container>
  );
};

FloatingControlsContainer.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  withMenu: PropTypes.bool,
};

FloatingControlsContainer.defaultProps = {
  classes: {},
  withMenu: false,
};

export default FloatingControlsContainer;
